



















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
  }
})

export default class deleteModal extends Vue {
    title = "削除しますか？";
    message = "一度削除をすると復元することができません。本当に削除しますか？";

    clickDeleteButton(){
        this.$emit('close');
        this.$emit('deleteData');
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBackgroundColor(){
        var style = {
            background: this.userConfigColor
        };
        return style;
    }
}
